import { createSlice } from '@reduxjs/toolkit';
import { addNewTransmission, editTransmission, getAllTransmissions } from './transmissionsService';

const initialState = {
  allTransmissions: {
    isTransmissionsLoading: null,
    isTransmissionsSuccess: null,
    transmissionsMessage: null,
    pageCount: 0,
    transmissions: [],
  },
  newTransmission: {
    isTransmissionCreating: null,
    isTransmissionCreated: null,
    transmissionCreationMsg: null,
  },

  editedTransmission: {
    isEditingTransmission: null,
    isTransmissionEdited: null,
    transmissionEditedMsg: null
  }
};

const transmissionsSlice = createSlice({
  name: 'transmission',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllTransmissions.pending, (state) => {
        state.allTransmissions = {
          ...initialState.allTransmissions, // Reset to initial state
          isTransmissionsLoading: true,
          transmissionsMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllTransmissions.rejected, (state, action) => {
        state.allTransmissions = {
          ...initialState.allTransmissions,
          isTransmissionsLoading: false,
          isTransmissionsSuccess: false,
          transmissionsMessage: action.payload || 'Error occurred while fetching transmissions',
        };
      })

      // FULFILLED
      .addCase(getAllTransmissions.fulfilled, (state, action) => {
        state.allTransmissions = {
          ...initialState.allTransmissions,
          isTransmissionsLoading: false,
          isTransmissionsSuccess: true,
          pageCount: action.payload.pageCount || 0,
          transmissions: action.payload.data || [],
        };
      });

    //Transmission creating
    builder
      .addCase(addNewTransmission.pending, (state) => {
        state.newTransmission = {
          ...initialState.newTransmission, // Reset to initial state
          isTransmissionCreating: true,
          transmissionCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewTransmission.rejected, (state, action) => {
        state.newTransmission = {
          ...initialState.newTransmission,
          isTransmissionCreating: false,
          isTransmissionCreated: false,
          transmissionCreationMsg: action.payload || 'Error occurred while creating the transmission.',
        };
      })

      // FULFILLED
      .addCase(addNewTransmission.fulfilled, (state, action) => {
        state.newTransmission = {
          ...initialState.newTransmission,
          isTransmissionCreating: false,
          isTransmissionCreated: true,
          transmissionCreationMsg: action.payload || 'Successfully created the transmission.',
        };
      });

    //Transmission editing
    builder
      .addCase(editTransmission.pending, (state) => {
        state.editedTransmission = {
          ...initialState.editedTransmission, // Reset to initial state
          isEditingTransmission: true,
          transmissionEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editTransmission.rejected, (state, action) => {
        state.editedTransmission = {
          ...initialState.editedTransmission, // Reset to initial state
          isEditingTransmission: false,
          isTransmissionEdited: false,
          transmissionEditedMsg: action.payload || 'Error occurred while editing the transmission.',
        };
      })

      // FULFILLED
      .addCase(editTransmission.fulfilled, (state, action) => {
        state.editedTransmission = {
          ...initialState.editedTransmission, // Reset to initial state
          isEditingTransmission: false,
          isTransmissionEdited: true,
          transmissionEditedMsg: action.payload || 'Successfully edited the transmission.',
        };
      });
  },
});

export default transmissionsSlice.reducer;
